import { render, staticRenderFns } from "./TextElement.vue?vue&type=template&id=41e3599e&"
import script from "./TextElement.vue?vue&type=script&lang=js&"
export * from "./TextElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports